import { produce } from 'immer';
import { initialState } from '../state';

import {
  RESET_FILTERS,
  RESET_SELECTION,
  SET_ATTRIBUTES,
  SET_AVAILABLE_FILTERS,
  SET_FILTER_PARAMS,
  SET_SELECTED,
  SET_TOTAL_DOWNLOADS,
} from '../actions';

export const dfReducer = produce((draft, action) => {
  switch (action.type) {
    case SET_ATTRIBUTES:
      draft.attributes = action.attributes;
      break;
    case SET_FILTER_PARAMS:
      draft.itemFilter = action.filter;
      break;
    case RESET_FILTERS:
      draft.params = [];
      draft.selected = {};
      draft.term = undefined;
      draft.itemFilter = initialState.itemFilter;
      break;
    case RESET_SELECTION:
      draft.params = [];
      draft.selected = {};
      break;
    case SET_SELECTED:
      if (draft.selected[action.depth] === action.id) {
        delete draft.selected[action.depth];
      } else {
        draft.selected[action.depth] = action.id;
      }
      Object.keys(draft.selected).forEach((depth) => {
        if (depth > action.depth) {
          delete draft.selected[Number(depth)];
        }
      });
      break;
    case SET_TOTAL_DOWNLOADS:
      draft.totalDownloads = action.totalDownloads || 0;
      break;
    case SET_AVAILABLE_FILTERS: {
      draft.availableFilters = action.value;
      break;
    }
    default:
      break;
  }
}, initialState);
